/**
 * <ReferralLinkRowSkeleton> — la forme de `<ReferralLinkRow>` pendant que le lien arrive.
 *
 * La même carte, le glyphe du lien et celui de la copie à leur place ; entre eux, la barre de
 * l'adresse.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../Card"

export function ReferralLinkRowSkeleton() {
    return (
        <Card p="3" background="surface">
            <Row align="center" gap="3">
                <Skeleton shape="circle" size={14} />
                <View style={styles.url}>
                    <Skeleton textSize="text-sm" width={210} />
                </View>
                <Skeleton shape="circle" size={16} />
            </Row>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    url: { flex: 1, flexShrink: 1 },
}))
